import { useCallback } from 'react';

import qs from 'qs';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useSession } from '#src/app/shared/hooks/session';

type Result = (options: { pathSuffix?: string; medium: string; additionalParams?: Record<string, string> }) => string;

export function useGenPetitionUrl(): Result {
	const session = useSession();
	const {
		data: {
			initial,
			petition: { slug, bestShareVisual },
			featureConfigs: { hideRecruiter, isShareAssetsEnabled },
		},
	} = usePsfSharePageData();

	const sessionUuid = session.uuid;
	const currentUserId = session.user?.id || undefined;
	const currentCampaign = session.trackingData.current_campaign || undefined;

	const shouldUseBsvPath = isShareAssetsEnabled && !!bestShareVisual?.url;

	return useCallback(
		({ pathSuffix, medium, additionalParams }) => {
			const effectivePathSuffix = shouldUseBsvPath ? `${pathSuffix ?? ''}/bsv` : (pathSuffix ?? '');

			const trackParams = qs.stringify(
				{
					...(hideRecruiter
						? {}
						: {
								recruiter: currentUserId || undefined,
								recruited_by_id: sessionUuid,
							}),
					utm_source: 'share_petition',
					utm_campaign: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
					utm_term: currentCampaign,
					utm_medium: medium,
					...additionalParams,
				},
				{ encodeValuesOnly: true },
			);
			return `/p/${slug}${effectivePathSuffix}?${trackParams}`;
		},
		[initial, sessionUuid, currentUserId, slug, currentCampaign, hideRecruiter, shouldUseBsvPath],
	);
}
